import Service1 from "assets/images/serviceicon0.svg";
import Service2 from "assets/images/serviceicon1.svg";
import Service3 from "assets/images/serviceicon2.svg";
import Service4 from "assets/images/serviceicon3.svg";

import EngMod1 from "assets/images/model.png";
import EngMod2 from "assets/images/model1.png";
import EngMod3 from "assets/images/model2.png";

import Ind1 from "assets/images/icon-education.svg";
import Ind2 from "assets/images/icon-healthcare.svg";
import Ind3 from "assets/images/icon-ecommerce.svg";
import Ind4 from "assets/images/icon-fintech.svg";
import Ind5 from "assets/images/icon-info.svg";
import Ind6 from "assets/images/icon-e-travel.svg";

import Goal1 from "assets/images/icon-steller-communication.svg";
import Goal2 from "assets/images/icon-visibility-transparency.svg";
import Goal3 from "assets/images/icon-delivery-process.svg";
import Goal4 from "assets/images/icon-iterate-towards-excellence.svg";
import Goal5 from "assets/images/icon-ownership-responsibility.svg";

import Values1 from "assets/images/icon-empathy.svg";
import Values2 from "assets/images/icon-quality.svg";
import Values3 from "assets/images/icon-transparency.svg";
import Values4 from "assets/images/icon-collaboration.svg";

import IconFigma from "assets/icons/figma.svg";
import IconIllustrator from "assets/icons/adobe-illustrator.svg";
import IconAdobeXD from "assets/icons/adobe-xd.svg";
import IconPhotoshop from "assets/icons/adobe-photoshop.svg";

import { FaNodeJs } from "react-icons/fa6";
import { RiFlutterFill, RiNextjsLine } from "react-icons/ri";
import { BiLogoPostgresql } from "react-icons/bi";
import { BsBootstrapFill } from "react-icons/bs";
import { DiReact, DiJavascript, DiHtml5, DiJqueryLogo, DiSass, DiAndroid } from "react-icons/di";
import { SiPrisma, SiMongodb, SiTypescript, SiTailwindcss, SiApple } from "react-icons/si";

export const SERVICES_DATA = [
  {
    image: Service2,
    title: "AI-Powered Mobile Apps",
    shortDesc:
      "Native and cross-platform apps (iOS, Android, React Native, Flutter) with on-device intelligence, conversational AI, and personalized experiences built in.",
    url: "#",
  },
  {
    image: Service1,
    title: "Intelligent Web Platforms",
    shortDesc:
      "Fast, scalable web apps in React & Next.js, augmented with AI search, recommendations, and copilots that turn your product into a smart assistant.",
    url: "#",
  },
  {
    image: Service3,
    title: "AI & LLM Integration",
    shortDesc:
      "We embed GPT-class models, RAG pipelines, and autonomous agents into your product — chatbots, automation, document intelligence, and custom copilots.",
    url: "#",
  },
  {
    image: Service4,
    title: "MVP & Product Engineering",
    shortDesc:
      "From idea to launch in weeks. We design, build, and ship AI-first MVPs that validate your concept and scale into production-grade products.",
    url: "#",
  },
];

export const ENGAGEMENT_MODELS_DATA = [
  {
    image: EngMod1,
    title: "Dedicated Individual/Teams",
    shortDesc:
      "Scale your development capacity with skilled professionals who work exclusively on your project, providing focused expertise and long-term commitment.",
    url: "#",
  },
  {
    image: EngMod2,
    title: (
      <>
        Fixed Cost
        <br /> Projects
      </>
    ),
    shortDesc:
      "Get predictable budgets and timelines with our fixed-cost model, perfect for well-defined projects with clear requirements and deliverables.",
    url: "#",
  },
  {
    image: EngMod3,
    title: "AI MVP For Startups",
    shortDesc:
      "Launch your AI-first idea with a production-ready MVP that validates your concept, wows investors, and scales into a real product.",
    url: "#",
  },
];

export const AI_CAPABILITIES_DATA = [
  {
    title: "Conversational AI & Copilots",
    desc: "In-app assistants, chatbots, and copilots powered by GPT and Claude that understand your domain and act on your data.",
  },
  {
    title: "RAG & Knowledge Retrieval",
    desc: "Retrieval-augmented generation over your documents and databases — accurate, cited answers grounded in your own content.",
  },
  {
    title: "Autonomous Agents & Automation",
    desc: "Multi-step AI agents that automate workflows, trigger actions, and integrate with the tools your business already uses.",
  },
  {
    title: "Intelligent Personalization",
    desc: "Recommendations, smart search, and adaptive UX that learn from user behavior to lift engagement and conversion.",
  },
  {
    title: "Document & Vision Intelligence",
    desc: "Extract, classify, and summarize text, PDFs, and images at scale with custom AI pipelines.",
  },
  {
    title: "On-Device & Edge AI",
    desc: "Fast, private intelligence that runs directly on mobile devices for real-time, offline-capable experiences.",
  },
];

export const TECHNOLOGIES_DATA = {
  ai: [
    { icon: <DiReact color="#10a37f" />, title: "OpenAI / GPT" },
    { icon: <DiReact color="#d97757" />, title: "Anthropic Claude" },
    { icon: <SiPrisma color="#5145ff" />, title: "LangChain" },
    { icon: <SiMongodb color="#22d3ee" />, title: "Vector DBs" },
    { icon: <FaNodeJs color="#3F873F" />, title: "RAG Pipelines" },
    { icon: <DiJavascript color="#F0DB4F" />, title: "AI Agents" },
  ],
  mobile: [
    { icon: <DiReact color="#61DAFB" />, title: "React Native" },
    { icon: <DiAndroid color="#83cb37" />, title: "Android" },
    { icon: <SiApple color="#000000" />, title: "iOS" },
    { icon: <RiFlutterFill color="#3ebef7" />, title: "Flutter" },
  ],
  frontend: [
    { icon: <DiReact color="#61DAFB" />, title: "React JS" },
    { icon: <RiNextjsLine />, title: "Next JS" },
    { icon: <FaNodeJs color="#3F873F" />, title: "Node JS" },
    // { icon: <BiLogoRedux color="#764abc" />, title: "Redux" },
    // { icon: <SiReacthookform color="#ec5990" />, title: "Readct Hook Form" },
    { icon: <DiJavascript color="#F0DB4F" />, title: "Javascript" },
    { icon: <SiTypescript color="#007acc" />, title: "Typescript" },
    { icon: <SiPrisma color="#336791" />, title: "Prisma" },
    { icon: <BiLogoPostgresql color="#336791" />, title: "PostgreSQL" },
    { icon: <SiMongodb color="#00Ed64" />, title: "Mongo" },
    { icon: <DiJqueryLogo />, title: "jQuery" },
    { icon: <DiHtml5 color="#E44D26" />, title: "HTML" },
    { icon: <SiTailwindcss color="#38bdf8" />, title: "Tailwind" },
    { icon: <BsBootstrapFill color="#604886" />, title: "Bootstrap" },
    { icon: <DiSass color="#CB6699" />, title: "SASS" },
  ],
  designing: [
    {
      icon: <img src={IconPhotoshop} alt="not found" />,
      title: "Adobe Photoshop",
    },
    {
      icon: <img src={IconIllustrator} alt="not found" />,
      title: "Adobe Illustrator",
    },
    { icon: <img src={IconAdobeXD} alt="not found" />, title: "Adobe XD" },
    { icon: <img src={IconFigma} alt="not found" />, title: "Figma" },
  ],
};

export const INDUSTRIES_DATA = [
  {
    img: Ind1,
    title: "Education",
    desc: "Empowering the future through innovative digital solutions. From e-learning platforms to interactive educational tools, we help institutions transform the way knowledge is delivered and experienced.",
  },
  {
    img: Ind2,
    title: "Healthcare",
    desc: "Enhancing patient care with cutting-edge technology. We provide digital solutions for telemedicine, patient management, and healthcare automation, ensuring seamless experiences for providers and patients alike.",
  },
  {
    img: Ind3,
    title: "E-commerce",
    desc: "Driving seamless shopping experiences with scalable e-commerce solutions. From intuitive UI/UX to secure payment integrations, we build platforms that enhance customer engagement and boost sales.",
  },
  {
    img: Ind4,
    title: "Fintech",
    desc: "Revolutionizing finance with secure and smart digital innovations. Our fintech solutions streamline transactions, enhance security, and bring efficiency to banking, payments, and financial management.",
  },
  {
    img: Ind5,
    title: "Information Technology",
    desc: "Powering digital transformation with cutting-edge IT solutions. Whether it's cloud computing, AI, or enterprise software, we enable businesses to leverage technology for growth and efficiency.",
  },
  {
    img: Ind6,
    title: "Travel",
    desc: "Creating unforgettable travel experiences through digital innovation. From booking systems to personalized itineraries, we help travel businesses offer seamless journeys to their customers.",
  },
];

export const OUR_GOALs_DATA = [
  {
    img: Goal1,
    title: "Steller Communication",
    desc: "Empowering the future through innovative digital solutions. From e-learning platforms to interactive educational tools, we help institutions transform the way knowledge is delivered and experienced.",
  },
  {
    img: Goal2,
    title: "Visibility & Transparency",
    desc: "Enhancing patient care with cutting-edge technology. We provide digital solutions for telemedicine, patient management, and healthcare automation, ensuring seamless experiences for providers and patients alike.",
  },
  {
    img: Goal3,
    title: "Delivery Process",
    desc: "Driving seamless shopping experiences with scalable e-commerce solutions. From intuitive UI/UX to secure payment integrations, we build platforms that enhance customer engagement and boost sales.",
  },
  {
    img: Goal4,
    title: "Iterate Towards Excellence",
    desc: "Revolutionizing finance with secure and smart digital innovations. Our fintech solutions streamline transactions, enhance security, and bring efficiency to banking, payments, and financial management.",
  },
  {
    img: Goal5,
    title: "Ownership & Responsibility",
    desc: "Powering digital transformation with cutting-edge IT solutions. Whether it's cloud computing, AI, or enterprise software, we enable businesses to leverage technology for growth and efficiency.",
  },
];

export const COMPANY_VALUES_DATA = [
  {
    img: Values1,
    title: "Empathy",
    desc: "We prioritize understanding and addressing the needs of our clients and users, ensuring solutions that truly make an impact.",
  },
  {
    img: Values2,
    title: "Quality",
    desc: "Commitment to excellence drives everything we do, delivering high-standard solutions that meet and exceed expectations.",
  },
  {
    img: Values3,
    title: "Transparency",
    desc: "We believe in open communication and honesty, fostering trust and long-term relationships with our clients and partners.",
  },
  {
    img: Values4,
    title: "Collaboration",
    desc: "Great ideas thrive in teamwork. We work closely with clients and teams to co-create innovative and effective solutions.",
  },
];
